import { render, staticRenderFns } from "./AddProgram.vue?vue&type=template&id=2cc3c06c&scoped=true&"
import script from "./AddProgram.vue?vue&type=script&lang=js&"
export * from "./AddProgram.vue?vue&type=script&lang=js&"
import style0 from "./AddProgram.vue?vue&type=style&index=0&id=2cc3c06c&lang=scss&scoped=true&"
import style1 from "./AddProgram.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3c06c",
  null
  
)

export default component.exports